import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TranslationFields from './TranslationFields';

class VariantsFields extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      scroll: 'paper',
    };
  }
  

  handleClickOpen = scroll => (event) => {
    event.stopPropagation();
    this.setState({ open: true, scroll });
  };

  handleClose = () => {
    this.setState({ open: false });
  };



  handleChange = (event, data) => {
    this.props.onChange(null, {
      ...data,
      parentField: 'variants'
    });
  }

  render() {
    const {
      fields
    } = this.props;

    return (
      <React.Fragment>
        <Button
          onClick={this.handleClickOpen('paper')}
          size="medium"
          variant="outlined"
          sx={styles.editBtn}>
          Edit variant translations
        </Button>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          scroll={this.state.scroll} 
          aria-labelledby="scroll-dialog-title"
          //maxWidth="md"
          fullWidth
        >
          <DialogTitle id="scroll-dialog-title">Edit Product Variants</DialogTitle>
          <DialogContent>
            <TranslationFields 
              data={fields} 
              nested
              isPending={this.props.isPending} 
              onChange={this.handleChange} 
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} size="small" variant="outlined">
              Cancel
            </Button>
            <Button onClick={this.handleClose} size="small" variant="outlined" color="primary">
              Done
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

const styles = {
  editBtn: {
    margin: '12px 0',
  }
};

export default VariantsFields;